// extracted by mini-css-extract-plugin
export default {"skill":"SkillItem_skill__xGqwh","label":"SkillItem_label__S03rv","wrapper":"SkillItem_wrapper__ktQtv"};